'use client';

import { TypedLocale } from 'payload';
import { createContext, useContext } from 'react';

const LocaleContext = createContext<{
  locale: TypedLocale;
  defaultLocale?: string;
  availableLocales: string[];
}>({
  locale: 'da',
  defaultLocale: 'da',
  availableLocales: ['da'],
});

export function useLocale() {
  return useContext(LocaleContext).locale;
}

export function useAvailableLocales() {
  return useContext(LocaleContext).availableLocales;
}

export function useDefaultLocale() {
  return useContext(LocaleContext).defaultLocale;
}

export function LocaleProvider({
  availableLocales,
  children,
  defaultLocale,
  locale,
}: {
  locale: TypedLocale;
  availableLocales: string[];
  defaultLocale?: string;
  children: React.ReactNode;
}) {
  return (
    <LocaleContext.Provider value={{ locale, availableLocales, defaultLocale }}>
      {children}
    </LocaleContext.Provider>
  );
}
